import { detailAdminAccount } from '@/services/iam-admin';
import type { AdminAccountDetail } from '@/types';
import { useEffect, useState } from 'react';

/** 顶栏与列表共用正式详情会话；关闭取消请求，晚响应不能重新打开。 */
export default function useAdminAccountDetail() {
  const [accountId, setAccountId] = useState<string>();
  const [detail, setDetail] = useState<AdminAccountDetail>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!accountId) return;
    const controller = new AbortController();
    void detailAdminAccount(accountId, { signal: controller.signal })
      .then(
        (value) => {
          if (!controller.signal.aborted) setDetail(value);
        },
        () => {
          // 正式请求出口显示错误，不用空详情冒充成功。
          if (!controller.signal.aborted) setAccountId(undefined);
        },
      )
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [accountId]);

  const show = (id: string) => {
    setDetail(undefined);
    setLoading(true);
    setAccountId(id);
  };
  const close = () => {
    setAccountId(undefined);
    setDetail(undefined);
    setLoading(false);
  };
  return { open: Boolean(accountId), detail, loading, show, close };
}
